module.exports = __webpack_public_path__ + "img/technology-24.23d87297.png";